var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    fill: "none",
    d: "M7.317 1.478c-.779.448-1.676 1.258-2.185 2.194s-.629 1.996-.66 2.851.03 1.519.061 2.153.03 1.246-.104 1.863-.401 1.237-.695 1.828l-.81 1.453c-.198.302-.276.345-.302.492s-.001.396 2.379.496l9.464.022 2.774-.244c.116-.102.15-.238.128-.329s-.099-.135-.298-.437-.517-.862-.81-1.453-.561-1.212-.695-1.828-.133-1.229-.103-1.863l.061-2.153c-.031-.854-.152-1.914-.661-2.851s-1.405-1.746-2.283-2.197c-2.06-.851-3.414-.773-5.262.003z",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    fill: "none",
    d: "M13.045 16.293a2.924 2.924 0 0 1-4.386 2.532 2.924 2.924 0 0 1-1.462-2.532",
    strokeWidth: 1.2,
    strokeLinejoin: "round",
    paintOrder: "markers stroke fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.a418fad8.svg";
export { ForwardRef as ReactComponent };